import { V3_STORES } from './v3';

/**
 * Schema version 4 — one new store. "Multi-user identity architecture"
 * review, round 2, §4/§10, Phase A.
 *
 * `exerciseUserState` is the sync-layer mirror of a catalogue exercise's
 * user-owned overlay (favourite/archived/notes/tags/override/media) — see
 * `ExerciseUserStateRecord` in `../types.ts` for the full rationale. Indexed
 * on `catalogueExerciseId` so `reconcileExerciseUserState()`
 * (`../sync/syncEngine.ts`) and the pull-merge path can look up "does this
 * device already have an overlay row for this exercise" without a full
 * table scan.
 *
 * Every other store is restated unchanged from {@link V3_STORES} — Dexie
 * treats each version's store map as the complete schema, so omitting one
 * would delete it.
 */
export const V4_STORES: Record<string, string> = {
  ...V3_STORES,
  exerciseUserState: 'id, catalogueExerciseId',
};
